export const formatTimeDiffWithMs = (start: number, end: number): string => {
	// Calculate total difference in milliseconds
	const totalMilliseconds: number = end - start;

	// Convert milliseconds to seconds, minutes, hours, days, and months for comparison
	const seconds: number = totalMilliseconds / 1000;
	const minutes: number = seconds / 60;
	const hours: number = minutes / 60;
	const days: number = hours / 24;
	const months: number = days / 30; // Approximation of a month
	const remainingSeconds: number = seconds % 60; // Remaining seconds after full minutes

	if (months > 12) {
		const years: number = months / 12;
		return `${Math.floor(years)} years, ${Math.floor(months % 12)} months`;
	} else if (months > 6) {
		return `${Math.floor(months)} months, ${Math.floor(days % 30)} days`;
	} else if (days > 10) {
		return `${Math.floor(days)} days, ${Math.floor(hours % 24)} hours`;
	} else if (days > 1) {
		return `${Math.floor(days)} days, ${Math.floor(hours % 24)} hours`;
	} else if (hours > 12) {
		return `${Math.floor(hours)} hours, ${Math.floor(minutes % 60)} minutes, ${remainingSeconds.toFixed(2)} seconds`;
	} else if (hours < 1) {
		// If there are 0 hours, return just minutes and remaining seconds
		return `${Math.floor(minutes)} minutes, ${remainingSeconds.toFixed(2)} seconds`;
	} else {
		// For time intervals less than 12 hours but more than 1 hour, return hours, minutes, and remaining seconds
		return `${Math.floor(hours)} hours, ${Math.floor(minutes % 60)} minutes, ${remainingSeconds.toFixed(2)} seconds`;
	}
};
